/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Resolution_LabelInputs */



/**
* | output |
* | --- |
* | "Resolution" |
*
* @param {Image_Export_Resolution_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_resolution_label = /** @type {((inputs?: Image_Export_Resolution_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Resolution_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resolution")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auflösung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risoluzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрешение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resolución")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("解决")
	if (locale === "ja") return /** @type {LocalizedString} */ ("解決")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resolução")
	return /** @type {LocalizedString} */ ("Resolution")
});